const _ = require("lodash");
const createReactClass = require("create-react-class");
const PT = require("prop-types");
const React = require("react");
const {PortalDestination} = require("../view/PortalDestination");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");

const ContainerSize = require("../util/ContainerSize");
const withContainerDims = require("../hoc/withContainerDims");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const {atPage, atUser} = require("../vault/StateCursors");
const OpsPage = require("../vault/OpsPage");
const OpsUser = require("../vault/OpsUser");
const Sounds = require("../util/Sounds");
const {
	shouldSimplifyNavigation,
	shouldRenderLeftSideNavBar,
	trackSimplifiedNavigationVariantImpression,
} = require("../util/NavigationUtil");
const {getFeatureFlag} = require("../util/FeatureFlags");

const BugReport = require("../view/BugReport");
const ServerErrorIndicator = require("../view/ServerErrorIndicator");
const ConfirmPageNavigation = require("../view/ConfirmPageNavigation");
const TeacherMenu = require("../view/TeacherMenu");
const GlobalModal = require("../view/GlobalModal");
const LevelUpModal = require("../view/LevelUpModal");
const NotificationModal = require("../view/NotificationModal");
const {
	PlacementLevelChangedModal,
} = require("../view/PlacementLevelChangeModal");
const MainTrainerBorder = require("./MainTrainerBorder");
const PageComponent = require("./PageComponent");
const SequenceSlideout = require("../view/SequenceSlideout");
const ScreenWarning = require("../view/ScreenWarning");
const LoadGuard = require("../view/LoadGuard");
const {LeftSideNav} = require("../view/LeftSideNav");
const {PageStudentScreenWarning} = require("../home/PageStudentScreenWarning");

const {FLAGS, FLAG_OPTIONS} = require("../util/GlobalFlags");

const styles = require("./styles/MainTrainerContainer.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withContainerDims(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, (props, vaultState) => ({
		page: atPage(vaultState).get(),
		user: atUser(vaultState).get(),
		connected: vaultState.connected,
		screenWarning: vaultState.screenWarning,
	}));
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "MainTrainerContainer",

		propTypes: {
			containerEl: PT.instanceOf(global.HTMLElement),

			// Injected by HOCs
			page: PT.object.isRequired,
			user: PT.object.isRequired,
			connected: PT.bool.isRequired,
			screenWarning: PT.string,

			dispatch: PT.func.isRequired,
			containerDims: PT.shape({
				width: PT.number.isRequired,
				height: PT.number.isRequired,
				left: PT.number.isRequired,
				top: PT.number.isRequired,
				windowWidth: PT.number.isRequired,
				windowHeight: PT.number.isRequired,
			}).isRequired,
		},

		componentDidMount: function() {
			// preload sounds to avoid latency with new sounds for slower connections
			Sounds.preloadAllSoundFiles();

			// prevent bounce-scrolling on iOS
			document.body && document.body.classList.add("no-bounce");
			this.updateContainerOverflow();
			this.updateRootFontSize();
			this.setState({
				hasLoggedSimplifiedNavigationVariant: false,
			});
			this.tryToLogSimplifiedNavigationVariant();
		},

		componentDidUpdate: function() {
			this.tryToLogSimplifiedNavigationVariant();
			this.updateContainerOverflow();
			this.updateRootFontSize();
		},

		componentWillUnmount: function() {
			document.body && document.body.classList.remove("no-bounce");
			this.removeContainerOverflow();
		},

		// Call this in both componentDidMount and componentDidUpdate,
		// in case user is already loaded at mount (coming from Office -> Trainer??)
		// Use this.state.hasLoggedSimplifiedNavigationVariant so we only log once.
		tryToLogSimplifiedNavigationVariant: function() {
			if (!this.props.user) return;
			if (
				this.state === null ||
				this.state.hasLoggedSimplifiedNavigationVariant
			)
				return;
			trackSimplifiedNavigationVariantImpression(this.props.user);
			this.setState({
				hasLoggedSimplifiedNavigationVariant: true,
			});
		},

		// Helper for updateContainerSize.
		// Classes here are global because element is passed in by props.
		updateContainerOverflow: function() {
			if (!this.props.containerEl) {
				return;
			}
			this.props.containerEl.classList.add("force-no-overflow");
			const {containerDims} = this.props;
			if (containerDims.width > containerDims.windowWidth + 1) {
				this.props.containerEl.classList.add("needs-scroll-x");
			} else {
				this.props.containerEl.classList.remove("needs-scroll-x");
			}
			if (containerDims.height > containerDims.windowHeight + 1) {
				this.props.containerEl.classList.add("needs-scroll-y");
			} else {
				this.props.containerEl.classList.remove("needs-scroll-y");
			}
		},

		removeContainerOverflow: function() {
			if (!this.props.containerEl) {
				return;
			}
			this.props.containerEl.classList.remove("force-no-overflow");
			this.props.containerEl.classList.remove("needs-scroll-x");
			this.props.containerEl.classList.remove("needs-scroll-y");
		},

		// Helper for updateContainerSize.
		updateRootFontSize: function() {
			const {user} = this.props;
			if (OpsUser.shouldSeeStudentOnboarding(user)) {
				document.documentElement.style.fontSize = "12px";
			} else if (global.document && document.documentElement) {
				const fontSize = ContainerSize.getFontSizes(this.props.containerDims)
					.root;
				document.documentElement.style.fontSize = fontSize + "px";
			}
		},

		render: function() {
			const {containerDims} = this.props;
			const bgStyle = {
				minWidth: containerDims.width,
				minHeight: containerDims.height,
			};

			const shouldRenderBorder = OpsPage.shouldRenderTrainerBorder(
				this.props.page
			);
			const shouldRenderLeftNav = shouldRenderLeftSideNavBar(this.props.page);

			const mainContainerStyle = shouldRenderLeftNav
				? {
						display: "flex",
						height: "100%",
				  }
				: {};
			const contentWrapperStyle = shouldRenderLeftNav
				? {
						position: "relative",
						width: "100%",
						height: "100%",
				  }
				: {};
			const contentStyle =
				shouldRenderLeftNav && !shouldRenderBorder
					? {
							width: "100%",
							height: "100%",
					  }
					: {
							top: containerDims.top,
							left: containerDims.left,
							width: containerDims.width,
							height: containerDims.height,
					  };

			const year = new Date().getFullYear();

			// Anything that should be clipped to the page area should be inside
			// the styles.content div. Anything allowed to show up outside that area
			// should be outside the content div.
			// For this reason, the main and content classes must not be positioned.

			const vaultProps = _.pick(this.props, ["page", "user", "connected"]);

			const {page, user} = this.props;
			const screenWarning = this.props.screenWarning;
			const showStudentScreenWarning =
				screenWarning &&
				(screenWarning === "student-phone" ||
					(screenWarning === "phone" &&
						(OpsUser.hasStudentRole(user) ||
							(user.load !== "done" && OpsPage.isStudentPage(page)))));

			if (showStudentScreenWarning) {
				return (
					<PageStudentScreenWarning
						user={user}
						fromParent={false}
						warning={screenWarning}
					/>
				);
			}
			if (screenWarning && screenWarning !== "ignore") {
				return <ScreenWarning warning={screenWarning} />;
			}

			const slideout =
				getFeatureFlag("ENABLE_REMOVE_SLIDEOUT") ||
				shouldSimplifyNavigation(this.props.page) ||
				OpsPage.isInStudentOnboarding(this.props.page) ||
				OpsPage.isInStudentTutorial(this.props.page) ||
				FLAGS.cleanMode ? null : (
					<LoadGuard
						identifier={"mainTrainerContainer"}
						status={vaultProps.user}
						renderLoaded={() => <SequenceSlideout {...vaultProps} />}
					/>
				);
			const additionalBundles = [];
			if (OpsPage.needsTrainerBundle(this.props.page)) {
				additionalBundles.push("trainer");
			}
			return (
				<div className={styles.main} style={mainContainerStyle}>
					{shouldRenderLeftNav && (
						<LeftSideNav {...vaultProps} dispatch={this.props.dispatch} />
					)}
					<div style={contentWrapperStyle}>
						<div className={styles.bg} style={bgStyle} />
						<div
							className={styles.jazz}
							style={
								FLAGS.cleanMode
									? {
											backgroundImage: "none",
											backgroundColor:
												FLAG_OPTIONS.cleanMode.appearance.backgroundColor,
									  }
									: {}
							}
						/>
						{shouldRenderBorder && (
							<MainTrainerBorder
								containerDims={containerDims}
								style={contentStyle}
							/>
						)}
						<div
							className={styles.content}
							style={{
								...contentStyle,
								...(FLAGS.cleanMode
									? {
											overflow: "visible",
									  }
									: {}),
							}}
							id="MainTrainerContent"
						>
							<PageComponent
								additionalBundles={additionalBundles}
								{...vaultProps}
							/>
							{slideout}
							<PortalDestination name={PORTAL_CONTAINERS.HOME_OVERLAY_MODAL} />
							<TeacherMenu {...vaultProps} />
							<PortalDestination name={PORTAL_CONTAINERS.TRAINER_SLIDER} />
							<PortalDestination name={PORTAL_CONTAINERS.TRAINER_LEADERBOARD} />
							<PortalDestination name={PORTAL_CONTAINERS.TRAINER_MESSAGE} />
							<PortalDestination name={PORTAL_CONTAINERS.GRADE_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.BOOK_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.VIDEO_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.HELP_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.TERMS_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.SPINNER} />
							<PortalDestination name={PORTAL_CONTAINERS.TOOLTIP} />
							<PortalDestination name={PORTAL_CONTAINERS.DEMO_SIGNUP_MODAL} />
							<PortalDestination name={PORTAL_CONTAINERS.BUG_MODAL} />
							<PortalDestination
								name={PORTAL_CONTAINERS.BUG_REPORT_STATUS_INDICATOR}
							/>
							<PortalDestination name={PORTAL_CONTAINERS.OFFICE_BAR} />
							<ConfirmPageNavigation />
							<GlobalModal />
							<LevelUpModal {...vaultProps} />
							<NotificationModal {...vaultProps} />
							<PlacementLevelChangedModal {...vaultProps} />
							<BugReport />
							<ServerErrorIndicator />
							{!shouldRenderLeftNav && (
								<div
									className={styles.copyright}
									style={
										FLAGS.cleanMode && FLAG_OPTIONS.cleanMode.misc.hideCopyright
											? {display: "none"}
											: {}
									}
								>
									© AoPS Inc. {year}
								</div>
							)}
						</div>
						<PortalDestination name={PORTAL_CONTAINERS.TOOL} />
						<PortalDestination name={PORTAL_CONTAINERS.INSTRUCTIONS_TOOL} />
					</div>
					<PortalDestination name={PORTAL_CONTAINERS.LEFT_NAV_MORE_MODAL} />
				</div>
			);
		},
	})
);
